module.exports = __webpack_public_path__ + "img/hez.49b9d319.svg";